import { api, ownDancerIdParam } from "../../lib/api";

export async function fetchFavoriteDances(eventId, { dancerId, occurrenceDate, signal }) {
  const r = await api.get(`/events/${eventId}/favorite-dances`, {
    params: {
      dancer_id: ownDancerIdParam(dancerId),
      occurrence_date: occurrenceDate || undefined,
    },
    signal,
  });
  return r.data;
}

export async function fetchOptInStatus(eventId, { dancerId, occurrenceDate }) {
  const r = await api.get(`/events/${eventId}/favorite-dances/opt-in`, {
    params: {
      dancer_id: ownDancerIdParam(dancerId),
      occurrence_date: occurrenceDate || undefined,
    },
  });
  return r.data;
}

export async function setOptInStatus(eventId, { dancerId, occurrenceDate, optedIn }) {
  const r = await api.post(`/events/${eventId}/favorite-dances/opt-in`, {
    dancer_id: ownDancerIdParam(dancerId),
    occurrence_date: occurrenceDate,
    opted_in: optedIn,
  });
  return r.data;
}

export async function submitFavoriteDances(eventId, { dancerId, occurrenceDate, voteeIds }) {
  const r = await api.post(`/events/${eventId}/favorite-dances/votes`, {
    dancer_id: ownDancerIdParam(dancerId),
    occurrence_date: occurrenceDate,
    votee_ids: voteeIds,
  });
  return r.data;
}

export async function skipFavoriteDances(eventId, { dancerId, occurrenceDate }) {
  const r = await api.post(`/events/${eventId}/favorite-dances/skip`, {
    dancer_id: ownDancerIdParam(dancerId),
    occurrence_date: occurrenceDate,
  });
  return r.data;
}

export async function fetchCrew(dancerId) {
  const r = await api.get(`/dancers/${dancerId}/crew`);
  return r.data?.crew || [];
}

export async function fetchAppreciation(dancerId) {
  const r = await api.get(`/dancers/${dancerId}/appreciation`);
  return r.data;
}
